module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/add-reg/add-reg.component.scss
// module id = ./src/app/components/add-reg/add-reg.component.scss
// module chunks = main